import React from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "./../Global/NanoFlex";
import { ReactComponent as Linkedin } from "./../Global/Icons/linkedin.svg";
import { ReactComponent as Twitter } from "./../Global/Icons/twitter.svg";

const multiple = nota.global.multiple;

const StyledSocialIcons = styled.div`
  a {
    padding: ${multiple + "px"}; /*8px*/
    svg {
      height: ${multiple * 2 + "px"}; /*16px*/
    }
    &:hover {
      opacity: 0.7;
    }
  }
`;

const SocialIcons = (props) => {
  return (
    <StyledSocialIcons>
      <NanoFlex>
        <a href="https://www.linkedin.com/company/glance-mediametrie/" title="Linkedin" rel="noopener noreferrer" target="_blank">
          <Linkedin />
        </a>
        <a href="https://twitter.com/glance_insights" title="Twitter" rel="noopener noreferrer" target="_blank">
          <Twitter />
        </a>
      </NanoFlex>
    </StyledSocialIcons>
  );
};

export default SocialIcons;

// --- // Documentation // --- //
/*

import SocialIcons from './../Nano/SocialIcons.js';

<SocialIcons />
*/
